export default {
    BILLNUMBER: 'merchants/bill-numbers/search/',
    ACCOUNT_SEARCH: 'merchants/account-search/',
    POST_GROUP: 'merchants/service-provider-groupings/'
}
